<template>
  <menu-layout>
    <div class="simple-mode" data-testid="simple-mode-page">
      <v-row class="mb-6">
        <v-col cols="12" md="7">
      <simple-upload-and-terms
        @upload-complete="onUploadComplete"
        @upload-started="refreshJobs"
      />
        </v-col>
        <v-col cols="12" md="5">
          <simple-job-queue-strip />
        </v-col>
      </v-row>

      <v-divider class="mb-6" />

      <simple-validate-carousel
        ref="validate"
        class="mb-6"
        @validated="onValidated"
      />

      <v-divider class="mb-6" />

      <simple-train-row
        ref="trainRow"
        @train-started="refreshJobs"
        @apply-started="refreshJobs"
      />
    </div>
  </menu-layout>
</template>

<script>
import MenuLayout from '@/components/layout/MenuLayout';
import SimpleUploadAndTerms from '@/components/simple_mode/SimpleUploadAndTerms.vue';
import SimpleJobQueueStrip from '@/components/simple_mode/SimpleJobQueueStrip.vue';
import SimpleValidateCarousel from '@/components/simple_mode/SimpleValidateCarousel.vue';
import SimpleTrainRow from '@/components/simple_mode/SimpleTrainRow.vue';
import LoadSettingsMixin from '@/mixins/LoadSettingsMixin';

export default {
  name: 'SimpleMode',
  components: {
    MenuLayout,
    SimpleUploadAndTerms,
    SimpleJobQueueStrip,
    SimpleValidateCarousel,
    SimpleTrainRow,
  },
  mixins: [LoadSettingsMixin],
  computed: {
    analysisJobCount() {
      return (this.$store.getters['project_live_jobs/llm_jobs'] || []).length;
    },
  },
  watch: {
    analysisJobCount(newVal, oldVal) {
      if (oldVal > newVal && this.$refs.validate) {
        this.$refs.validate.refresh();
      }
    },
  },
  mounted() {
    const projectId = this.$store.getters['user/get_current_project_id'];
    if (projectId && projectId !== 'false') {
      sessionStorage.setItem('project_id', String(projectId));
    }
    this.$store.dispatch('setting/all', { force_reload: true });
  },
  methods: {
    onUploadComplete() {
      this.refreshJobs();
      if (this.$refs.validate) {
        this.$refs.validate.refresh();
      }
    },
    onValidated() {
      if (this.$refs.trainRow) {
        this.$refs.trainRow.refreshValidatedCount();
      }
    },
    refreshJobs() {
      this.$store.dispatch('project_live_jobs/ensure_subscribed');
      this.$store.dispatch('project_live_jobs/fetch_active');
    },
  },
};
</script>

<style scoped>
.simple-mode {
  max-width: 1400px;
  margin: 0 auto;
  padding: 8px 8px 32px;
}
</style>
